// Gdfuture.jsx
import React, { useEffect, useRef, useState } from "react";
import "../Style/Gdfuture.css";

import limage from "../assets/L.png";
import vimage from "../assets/V.png";
import pimage from "../assets/P.png";
import cimage from "../assets/C.png";
import uimage from "../assets/U.png";

const services = [
  {
    id: 1,
    icon: limage,
    alt: "Logo & Brand Identity",
    title: "Logo & Brand Identity",
    text: "A professional logo and consistent brand identity help businesses create a memorable impression and build trust with their audience.",
    row: "top",
  },
  {
    id: 2,
    icon: vimage,
    alt: "Visual Marketing Designs",
    title: "Visual Marketing Designs",
    text: "Creative marketing graphics such as banners, social media posts, and promotional creatives help businesses communicate their message effectively.",
    row: "top",
  },
  {
    id: 3,
    icon: pimage,
    alt: "Print & Promotional Materialst",
    title: "Print & Promotional Materialst",
    text: "Brochures, pamphlets, posters, and other print materials present your products and services clearly while strengthening brand recognition.",
    row: "top",
  },
];

const Gdfuture = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`gdfuture-main-section ${isVisible ? "gdfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="gdfuture-glow gdfuture-glow-1" aria-hidden="true" />
      <div className="gdfuture-glow gdfuture-glow-2" aria-hidden="true" />

      <div className="gdfuture-main-container">
        <span className="gdfuture-eyebrow gdfuture-anim gdfuture-anim-0">
          Our Approach
        </span>

        {/* Heading */}
        <h1 className="gdfuture-main-title gdfuture-anim gdfuture-anim-1">
          The Power of Creative Graphic Design
        </h1>

        {/* Delivered by */}
        <p className="gdfuture-subtitle-label gdfuture-anim gdfuture-anim-2">
          Delivered by MPeoples
        </p>

        {/* Description */}
        <p className="gdfuture-main-description gdfuture-anim gdfuture-anim-3">
          Graphic design is more than just visuals — it is the creative
          language that communicates your brand's story. At MPeoples, we
          combine creativity, strategy, and modern design tools to create
          impactful visuals that help businesses attract customers, build
          strong brand identity, and stand out in a competitive market.
        </p>

        {/* Cards Grid */}
        <div className="gdfuture-card-grid">
          {/* Top row — 3 cards */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <div
                key={service.id}
                className={`gdfuture-service-card gdfuture-anim gdfuture-anim-${4 + i}`}
              >
                <div className="gdfuture-card-header">
                  <div className="gdfuture-card-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.alt}
                      className="gdfuture-card-icon"
                    />
                  </div>
                  <h3 className="gdfuture-card-title">{service.title}</h3>
                </div>
                <p className="gdfuture-card-text">{service.text}</p>
              </div>
            ))}

          {/* Bottom row — 2 cards */}
          <div className="gdfuture-service-card gdfuture-card-bottom-left gdfuture-anim gdfuture-anim-7">
            <div className="gdfuture-card-header">
              <div className="gdfuture-card-icon-wrap">
                <img
                  src={cimage}
                  alt="Creative Advertising Graphics"
                  className="gdfuture-card-icon"
                />
              </div>
              <h3 className="gdfuture-card-title">
                Creative Advertising Graphics
              </h3>
            </div>
            <p className="gdfuture-card-text">
              High-quality advertising visuals help capture attention,
              increase engagement, and support successful marketing
              campaigns.
            </p>
          </div>

          <div className="gdfuture-service-card gdfuture-card-bottom-right gdfuture-anim gdfuture-anim-8">
            <div className="gdfuture-card-header">
              <div className="gdfuture-card-icon-wrap">
                <img
                  src={uimage}
                  alt="Modern Design Solutions"
                  className="gdfuture-card-icon"
                />
              </div>
              <h3 className="gdfuture-card-title">Modern Design Solutions</h3>
            </div>
            <p className="gdfuture-card-text">
              Using modern design trends and tools, we create clean,
              professional, and visually appealing graphics that enhance
              your brand presence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gdfuture;